import React from 'react';
import { Link } from 'react-router-dom';
import { css } from 'glamor';
import map from 'lodash/map';
import Ribbon from '../../containers/Ribbon';
import profilePic from './assets/lucastswick-avatar.jpg';
import Twitter from 'react-icons/lib/io/social-twitter-outline';
import Instagram from 'react-icons/lib/io/social-instagram-outline';

import { bioWrapper, bioInner, avatarStyle, header, li } from './styles';
import {
  textContainer,
  center,
  removeMarginBottom,
  removeMarginVertical,
  shadowless,
  bulletless,
  removePaddingBottom,
  removePaddingVertical,
  thirdWidth,
  fullWidthSm,
  hideOnPrint,
} from '../../styles';

class Bio extends React.Component {
  componentWillMount() {
    this.props.loadTheme();
    this.props.load();
  }

  render() {
    let { theme, work } = this.props;

    const buttonStyle = css({
      color: theme.colors[1],
      '&:hover': {
        color: theme.colors[1],
        textDecoration: 'underline',
      },
    });

    const textColor = css({
      color: '#f1eee6',
    });

    return (
      <div
        {...css({
          backgroundColor: theme.colors[0],
        })}
        {...bioWrapper}
        {...removeMarginBottom}
        {...hideOnPrint}
      >
        <div {...textContainer} {...bioInner} {...removePaddingBottom}>
          <Link {...shadowless} to={'/'} {...fullWidthSm}>
            <img src={profilePic} alt={`Lucas Swick`} {...avatarStyle} />
          </Link>
          <div {...thirdWidth} {...fullWidthSm} {...textColor}>
            <h4 {...header} {...textColor}>
              lucastswick
            </h4>
            <ul {...css({ marginLeft: 0 })}>
              <li {...bulletless} {...li}>
                <Link {...shadowless} to={'/'} {...buttonStyle}>
                  Home
                </Link>
              </li>
              <li {...bulletless} {...li}>
                <Link {...shadowless} to={'/about'} {...buttonStyle}>
                  About
                </Link>{' '}
                |{' '}
                <Link {...shadowless} to={'/cv'} {...buttonStyle}>
                  CV
                </Link>
              </li>
              <li {...bulletless} {...li}>
                <Link
                  {...shadowless}
                  to={'/immersive-scholar-residency-at-NCSU'}
                  {...buttonStyle}
                >
                  Immersive Scholar
                </Link>{' '}
              </li>
              <li {...bulletless} {...li} {...css({ display: 'none' })}>
                <Link
                  {...shadowless}
                  to={'/what-i-do-at-easykicks'}
                  {...buttonStyle}
                >
                  Nike Job Description
                </Link>{' '}
              </li>
              <li {...bulletless} {...li}>
                <Link {...shadowless} to={'/contact'} {...buttonStyle}>
                  Contact
                </Link>{' '}
              </li>
              <li {...bulletless} {...li}>
                <a
                  {...shadowless}
                  {...buttonStyle}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  href="https://instagram.com/lucastswick"
                >
                  <Instagram size={45} />
                </a>{' '}
                <a
                  {...shadowless}
                  {...buttonStyle}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  href="https://twitter.com/lucastswick"
                >
                  <Twitter size={45} />
                </a>
              </li>
            </ul>
          </div>
          <div {...thirdWidth} {...fullWidthSm}>
            <h4 {...header} {...textColor}>
              Work
            </h4>
            <ul {...css({ marginLeft: 0 })}>
              {map(work, w => {
                return (
                  <li key={w.uid} {...bulletless} {...li}>
                    <Link {...shadowless} to={w.link} {...buttonStyle}>
                      {w.title}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        <div
          {...textContainer}
          {...center}
          {...removePaddingVertical}
          {...removeMarginVertical}
          {...textColor}
        >
          <p>
            Copyright © {new Date().getFullYear()} lucastswick. All rights
            reserved.<br />This site rebuilds itself differently every time.{' '}
            <a
              {...shadowless}
              {...buttonStyle}
              onClick={() => window.location.reload()}
            >
              Refresh
            </a>
          </p>
        </div>
        <Ribbon />
      </div>
    );
  }
}

export default Bio;



// WEBPACK FOOTER //
// ./src/components/Bio/Bio.js